/** @format */

import React from "react";

import { Outlet } from "react-router-dom";
import Header from "../../components/partials/dashboard/HeaderStyle/pub-header";

const PublicLayout = () => {
  return (
    <>
      <div className="main-content">
        <div className="position-relative">
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default PublicLayout;
